import axios from 'axios';
import { parseCookies } from 'nookies';

const cookies = parseCookies();
const accessToken = cookies['riderize@accessToken'];
const refreshToken = cookies['riderize@refreshToken'];

interface IHandleToast {
  (
    severity: 'error' | 'success' | 'warning' | 'info',
    message: string,
    duration?: number
  ): void;
}

type Props = {
  routeId: string;
  routeName: string;
  handleToast: IHandleToast;
};

const downloadGPX = async ({
  routeId,
  routeName,
  handleToast
}: Props): Promise<void> => {
  const routeNameWithoutBlankSpaces = routeName.replaceAll(' ', '-');

  try {
    await axios
      .get(
        `${process.env.NEXT_PUBLIC_API_URL}/export/route/${routeId}?extension=gpx`,
        {
          headers: {
            languagecode: 'pt-BR',
            authorization: `Bearer ${accessToken}`,
            'x-refresh-token': `Bearer ${refreshToken}`
          },
          responseType: 'arraybuffer'
        }
      )
      .then(response => {
        const type = response.headers['content-type'];
        const blob = new Blob([response.data], {
          type: type
        });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = `${routeNameWithoutBlankSpaces}.gpx`;
        link.click();
      });
  } catch (error) {
    handleToast('error', 'Erro ao fazer o download do arquivo');
    throw new Error((error as Error).message);
  }
};

export default downloadGPX;
